/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  createDialogRoute,
  FormState,
  FormStateBuilder,
  getDialogInitData,
} from '@gh/common-shared';
import { AutocompleteLoadMoreEvent, DialogInput, EmptyDialogInput } from '@gh/core-ui';
import { ScheduleListBusinessService } from '../../resources/schedule-list-business.service';
import { SalesScheduleCreate, ScheduleTemplateListItem } from '../../resources/schedule-list.model';

@Component({
  standalone: false,
  selector: 'gh-sales-schedule-create-dialog',
  templateUrl: 'sales-schedule-create-dialog.component.html',
  styleUrls: ['sales-schedule-create-dialog.component.scss'],
})
export class SalesScheduleCreateDialogComponent implements OnInit, DialogInput<EmptyDialogInput> {
  input: EmptyDialogInput;

  form: FormState<SalesScheduleCreate>;
  templates: ScheduleTemplateListItem[];

  constructor(@Inject(MAT_DIALOG_DATA) private dialogData: any,
              private dialogRef: MatDialogRef<any>,
              private formStateBuilder: FormStateBuilder,
              private business: ScheduleListBusinessService) {
  }

  ngOnInit(): void {
    const { templates } = getDialogInitData(this.dialogData);

    this.templates = templates;
    this.form = this.formStateBuilder.buildPlain({
      children: {
        salesFolderId: { required: true },
        templateId: { required: true },
      },
    });
  }

  loadSalesFolders(event: AutocompleteLoadMoreEvent): void {
    event.load(this.business.findAllSalesFolders(event.query));
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onCreate(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.dialogRef.close(this.form.submitValue);
  }
}

export const salesScheduleCreateDialogRoute = createDialogRoute({
  component: SalesScheduleCreateDialogComponent,
  init: {
    service: ScheduleListBusinessService,
    selector: 'initSalesScheduleDialogView',
  },
});
